module.exports = __webpack_public_path__ + "media/images/icon-map-active-4b53b53926f3a40970fbf8b4dc3a3e5c.svg";